import { KlevuConfig } from "@klevu/core";

export function useKlevuConfig(): KlevuConfig {
  const { store, locale } = useI18nExtend();

  const domain = import.meta.server
    ? `http://127.0.0.1:${process.env.VSF_NUXT_APP_PORT ?? 3560}/`
    : "/";

  const config = new KlevuConfig({
    url: `${domain}klevu-api/${store.value.code}/${locale.value}/search`,
    apiKey: "---protected---",
  });

  config.eventsApiV1Url = `${domain}klevu-api/${store.value.code}/${locale.value}/analytics/`;

  // Klevu config initializes in the nitro plugin on the server side.
  // Klevu events are not supported on the server side so far
  if (!import.meta.server && !KlevuConfig.default) {
    KlevuConfig.init({
      url: "protected",
      apiKey: "---protected---",
    });
    KlevuConfig.default!.eventsApiV1Url = `${domain}klevu-api/analytics/`;
  }

  if (import.meta.server && !KlevuConfig.default) {
    throw new Error(
      "Klevu config is not initialized, please check your define-klevu-config.nitro.ts plugin",
    );
  }

  return config;
}
